export default __webpack_public_path__ + "static/rapture-93f161a20b7c4c5109672afd0f1f30d1.jpg";